
export function distance(a, b) {
    return Math.abs(a - b);
}

export function distanceDown(a, b) {
    const diff = a - b;
    return diff < 0 ? 0 : diff;
}

export function average(a, b) {
    return Math.round((a / b) * 100);
}

export function pluralize(count, noun, suffix = 's') {
    return `${count} ${noun}${count !== 1 ? suffix : ''}`;
}

let USDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
});

export function currency( amount ) {
    return USDollar.format( amount );
}

export function shuffle(array = [...array]) {
    let currentIndex = array.length;

    // While there remain elements to shuffle...
    while (currentIndex != 0) {
      // Pick a remaining element...
      let randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      // And swap it with the current element.
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex], array[currentIndex]];
    }
    return array;
}

export function randomDate(start, end) {
    return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
}

export function stripLeadingZeros (str) {
    return str.replace(/^0+/, '');
};